import { create } from 'zustand';

interface WaitOverlayStore {
    isWaiting: boolean;
    label: string;
    setWaiting: (waiting: boolean, label?: string) => void;
}

const DEFAULT_LABEL = 'Loading...';

export const useWaitOverlayStore = create<WaitOverlayStore>((set) => ({
    isWaiting: false,
    label: DEFAULT_LABEL,
    setWaiting: (waiting, label) => set({ isWaiting: waiting, label: waiting ? (label ?? DEFAULT_LABEL) : DEFAULT_LABEL }),
}));
